import { useContext } from "react";
import { useTranslation } from "react-i18next";
import UserContext from "../../state/UserContext";
import { imageHelper } from "../../helpers";

/**
 * Full-screen holding page shown when the company is in maintenance mode
 * and the signed-in user does not have Platform Configuration permission.
 */
function MaintenancePage() {
  const { t } = useTranslation();
  const userContext = useContext(UserContext);
  const client = userContext.user.client;

  const logoUrl = client.logoFilename
    ? imageHelper.getImagePath(client.logoFilename, 280)
    : null;

  const customMessage = client.maintenanceModeMessage?.trim();
  const bodyText =
    customMessage ||
    t(
      "Pages.Maintenance.DefaultBody",
      "Your company is currently making changes to {{productName}}. Please try again shortly.",
      { productName: client.productName }
    );

  return (
    <div className="min-h-screen w-full bg-white flex items-center justify-center px-6">
      <div className="max-w-lg w-full text-center space-y-6">
        {logoUrl && (
          <img
            src={logoUrl}
            alt={client.name}
            className="mx-auto max-h-16 max-w-[14rem] object-contain"
          />
        )}
        <h1 className="text-2xl font-semibold text-gray-900">
          {t("Pages.Maintenance.Title", "Maintenance in Progress")}
        </h1>
        <p className="text-base text-gray-600 leading-relaxed">{bodyText}</p>
      </div>
    </div>
  );
}

export default MaintenancePage;
